import { Injectable, computed, inject, signal } from '@angular/core';
import { OauthClient, WebKeySetResponse } from '@rhapsody/ngx-api-key-client';

import { OidcSecurityService } from 'angular-auth-oidc-client';
import { OidcSecurityTokenState } from '@core/models';

@Injectable({
  providedIn: 'root',
})
export class OidcSecurityTokenService {
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly oauthClient = inject(OauthClient);

  readonly #state = signal<OidcSecurityTokenState>({
    signingKeys: '',
    accessToken$: this.oidcSecurityService.getAccessToken(),
    accessTokenJson$: this.oidcSecurityService.getPayloadFromAccessToken(),
    idToken$: this.oidcSecurityService.getIdToken(),
    idTokenJson$: this.oidcSecurityService.getPayloadFromIdToken(),
  });

  readonly state = computed(() => this.#state());
  readonly signingKeys = computed(() => this.#state().signingKeys);
  readonly accessToken$ = computed(() => this.#state().accessToken$);
  readonly accessTokenJson$ = computed(() => this.#state().accessTokenJson$);
  readonly idToken$ = computed(() => this.#state().idToken$);
  readonly idTokenJson$ = computed(() => this.#state().idTokenJson$);

  public fetchAuthKeys() {
    this.setKeys('Loading...');
    this.oauthClient.keys().subscribe({
      next: (res: WebKeySetResponse) => {
        const restStr = JSON.stringify(res, null, 2);
        this.setKeys(restStr);
      },
      error: (err) => {
        const errStr = JSON.stringify(err, null, 2);
        this.setKeys(errStr);
      },
    });
  }

  private setKeys(signingKeys: string) {
    this.#state.update((state) => ({
      ...state,
      signingKeys,
    }));
  }
}
